// Unpublished Work © 2026 Deere & Company.

import React from 'react';

export default function useReportExportDialog(onDownload, isPreviewEnabled) {
    const [isOpen, setIsOpen] = React.useState(false);
    const handleOpen = React.useCallback(async () => {
        if (isPreviewEnabled) {
            setIsOpen(true);
        } else {
            await onDownload();
        }
    }, [isPreviewEnabled, onDownload]);
    const handleClose = () => setIsOpen(false);
    const handleDownload = React.useCallback(async () => {
        await onDownload();
        setIsOpen(false);
    }, [onDownload]);

    return {
        handleClose,
        handleDownload,
        handleOpen,
        isOpen
    };
}
